import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Blacklist } from 'src/model/blacklist';
import { BlacklistService } from 'src/services/blacklist.service';

@Component({
    selector: 'app-edit-blacklist',
    templateUrl: './edit-blacklist.component.html',
    styleUrl: './edit-blacklist.component.scss',
    standalone: false
})
export class EditBlacklistComponent implements OnInit{
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  private blacklistService = inject(BlacklistService);

  @Input() blacklist: Blacklist;
  updatedBlacklist: Blacklist;
  disabledSubmit = false;

  @Output() passEntry = new EventEmitter<any>();

  ngOnInit(): void {
    this.updatedBlacklist = Object.assign({}, this.blacklist);
  }

  requiredValidator(value: string | null): boolean {
    return value && value.trim() !== '';
  }

  validFields() {
    return this.requiredValidator(this.updatedBlacklist.Name) && this.requiredValidator(this.updatedBlacklist.ICNumber) && this.requiredValidator(this.updatedBlacklist.Remark) && this.requiredValidator(this.updatedBlacklist.Status);
  }

  async updateBlacklistCustomer() {
    this.disabledSubmit = true;
    this.updatedBlacklist.ICNumber = this.sharedService.sanitizeICNumInput(this.updatedBlacklist.ICNumber);
    try {
      await this.blacklistService.updateBlacklistCustomer(this.updatedBlacklist);
      this.reset();
      this.sharedService.openAlert("Successfully updated profile", ALERT_TYPE.SUCCESS);
      this.passEntry.emit(this.updatedBlacklist);
    } finally {
      this.disabledSubmit = false;
    }
  }

  submit() {
    this.validFields() ? this.updateBlacklistCustomer() : this.sharedService.openAlert("Please fill in all the fields correctly", ALERT_TYPE.DANGER);
  }

  reset() {
    this.activeModal.close();
  }
}
